import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { Alert } from '@cmsgov/ds-medicare-gov'

export interface MspErrorPageProps {}

export const MspErrorPage:React.FC<MspErrorPageProps> = () => {
  const { t } = useTranslation('msp')

  return (
    <>
      <ContentLayout
        className="ds-u-padding-bottom--7"
        width="wide"
        heading={t('errorPage.title')}
      >
        <div className="ds-l-container my-c-Msa">
          <div className="ds-l-row">
            <div className="ds-l-col--12">
              <Alert variation="warn" className="my-u-mb--14">
                <p className="ds-c-alert__text">{t('errorPage.alert')}</p>
              </Alert>
            </div>
          </div>
        </div>
      </ContentLayout>
    </>
  )
}
